import React, { useEffect, useState } from 'react'
import { Button, Col, Row, Typography } from 'antd';
import { useDebounce } from '../../../common/debounce';
import { ORG_ID, REACT_APP_API } from '../../../constants';
import axios from 'axios';
import DataGridTable from '../../ui/DataGridTable';
import { ArrowDownWideNarrowIcon, ArrowUpNarrowWideIcon, SquarePenIcon } from 'lucide-react';
import { AutoCompleteInput } from '../../ui/common';

function EntraUsers() {
  const { Title } = Typography;
  const [entraUsers, setEntraUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(1);
  const PAGESIZE = 20;
  const [paginationParams, setPaginationParams] = useState({ current: 1, pageSize: PAGESIZE });

  const [emailSearch, setEmailSearch] = useState("");
  const [emailOptions, setEmailOptions] = React.useState([]);
  const debouncedValue = useDebounce(emailSearch, 500);

  const handleSearch = (value) => {
    if (!value) {
      setEmailOptions([]);
      return;
    }

    const filteredOptions = entraUsers
      .filter((user) => user.email.toLowerCase().includes(value.toLowerCase()))
      .map((user) => ({
        label: user.email,
        value: user.email,
      }));

    setEmailOptions(filteredOptions);
  };

  useEffect(() => {
    fetchEntraUser();
  }, [paginationParams]);

  useEffect(() => {
    fetchEntraUser();
  }, [debouncedValue])

  const customDataGridValues = (data) => {
    return data?.map((item) => {
      const { id, displayName, mail, userPrincipalName } = item;
      return {
        id,
        displayName,
        email: mail === "" ? userPrincipalName : mail,
        accountType: "Entra"
      }
    })
  }

  const fetchEntraUser = () => {
    let data = {
      org_id: ORG_ID(),
      page: paginationParams?.current,
      limit: paginationParams?.pageSize,
      search: emailSearch,
      "filter_by": "",
      "filter_value": "",
      "sort_by": "",
      "sort_order": "",
    };
    setIsLoading(true);
    axios
      .post(`${REACT_APP_API}/ad/GetEntraUsers`, data, {
        headers: {
          "Content-Type": "application/json"
          // withCredentials: true,
          // "X-Authorization": AUTH_TOKEN(),
        },
      })
      .then((res) => {
        setIsLoading(false);
        const data = customDataGridValues(res?.data?.users);
        setEntraUsers(data || []);

        if (emailSearch === "") setEmailOptions([])
        else {
          const filteredOptions = data?.map((user) => ({
            label: user.email,
            value: user.email,
          }));
          setEmailOptions(filteredOptions);
        }
        setTotalCount(res?.data?.pagination?.total);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  // implementing new data table
  const dataTableColumns = [
    {
      key: "edit", align: "center", width: 60, render: (val) => (
        <Button type="link">
          <SquarePenIcon className='!h-4' />
        </Button>
      ),
    },
    { title: "Entra ID", key: "id", dataIndex: "id" },
    {
      title: "Email", key: "email", dataIndex: "email",
      sorter: (a, b) => a.email.length - b.email.length,
    },
    { title: "Username", key: "displayName", dataIndex: "displayName" },
    { title: "Account Type", key: 'accountType', dataIndex: "accountType" }
  ]

  return (
    <>
      <Row className="content-conatiner">
        <Col className='space-y-5' span={24}>
          <Row justify="space-between">
            <Col>
              <Title level={3}>Entra Users</Title>
            </Col>
          </Row>
          <Row>
            <Col className='space-y-6' span={24}>
              <div className='grid grid-cols-4 gap-3'>
                <AutoCompleteInput
                  label={"Email"}
                  handleSearch={handleSearch}
                  handleOnChange={(value) => {
                    setPaginationParams((prev) => ({...prev, current: 1 }) )
                    setEmailSearch(value);
                  }}
                  options={emailOptions}
                />
              </div>
              <DataGridTable
                isLoader={isLoading}
                totalCount={totalCount}
                data={entraUsers}
                columns={dataTableColumns}
                pagination={paginationParams}
                handleChangePagination={
                  (page, pageSize) => { setPaginationParams({ current: page, pageSize }); }
                }
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

export default EntraUsers
